"use client";

import { motion } from "motion/react";
import React from "react";

export interface testimonial {
	text: string;
	image: string;
	name: string;
	role: string;
}

export type testimonials = testimonial[];

export const TestimonialsColumn = (props: {
	className?: string;
	testimonials: testimonials;
	duration?: number;
}) => {
	return (
		<div className={props.className}>
			<motion.div
				animate={{
					translateY: "-50%",
				}}
				transition={{
					duration: props.duration || 10,
					repeat: Number.POSITIVE_INFINITY,
					ease: "linear",
					repeatType: "loop",
				}}
				className="flex flex-col gap-6 pb-6 bg-background"
			>
				{[
					...new Array(2).fill(0).map((_, index) => (
						// biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
						<React.Fragment key={index}>
							{props.testimonials.map(({ text, image, name, role }, i) => (
								<div
									className="p-10 rounded-3xl border shadow-lg shadow-primary/10 max-w-xs w-full"
									// biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
									key={i}
								>
									<div>{text}</div>
									<div className="flex items-center gap-2 mt-5">
										<img
											width={40}
											height={40}
											src={image}
											alt={name}
											className="h-10 w-10 rounded-full"
										/>
										<div className="flex flex-col">
											<div className="font-medium tracking-tight leading-5">
												{name}
											</div>
											<div className="leading-5 opacity-60 tracking-tight">
												{role}
											</div>
										</div>
									</div>
								</div>
							))}
						</React.Fragment>
					)),
				]}
			</motion.div>
		</div>
	);
};
